export function requireApiBaseURL(brandId: string): string {
  const value = (import.meta.env as { readonly VITE_API_URL?: string }).VITE_API_URL
  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(`VITE_API_URL is required for ${brandId} checkout`)
  }
  return value.trim().replace(/\/+$/, '')
}

export function requireProductReturnOrigin(brandId: string): string {
  const value = (import.meta.env as { readonly VITE_DEFAULT_SUCCESS_URL?: string })
    .VITE_DEFAULT_SUCCESS_URL
  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(`VITE_DEFAULT_SUCCESS_URL is required for ${brandId} checkout`)
  }
  const url = new URL(value.trim())
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) {
    throw new Error(`VITE_DEFAULT_SUCCESS_URL is invalid for ${brandId} checkout`)
  }
  return url.origin
}

export type VisivaSiteCode = 'visiva_old' | 'visiva_new'

const VISIVA_SITE_CODES = new Set<VisivaSiteCode>(['visiva_old', 'visiva_new'])

export function parseVisivaSiteCode(value: string | undefined): VisivaSiteCode {
  const normalized = value?.trim()
  if (!normalized || !VISIVA_SITE_CODES.has(normalized as VisivaSiteCode)) {
    throw new Error('VITE_SITE_CODE must be visiva_old or visiva_new for visiva checkout')
  }
  return normalized as VisivaSiteCode
}

export function requireVisivaSiteCode(): VisivaSiteCode {
  const value = (import.meta.env as { readonly VITE_SITE_CODE?: string }).VITE_SITE_CODE
  return parseVisivaSiteCode(value)
}
